export class BillingDiscountDto {
  rec_status?: string;
  external_id?: string;
  calculation_type?: string;
  line_type?: string;
  amount?: number;
  currency_amount?: number;
  rate?: number;
  exchange_rate?: number;
}
